import { SVGProps } from 'react';
const SvgArrowDownRightSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m8 8 8 8M16 10v6h-6"
    />
  </svg>
);
export default SvgArrowDownRightSm;
